import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import ic_blue_cube from "../img/ic_blue_cube.png";
import Header from "./Header";
import axios from "axios";
import "../css/PreviousOrderDetailPage.css";
import ic_dropdown_status from "../img/ic_dropdown_status.png";
import LoadingUI from "./LoadingUI";
import { Link } from "react-router-dom";

function PreviousOrderDetailPage(props) {

    const location = useLocation();
    console.log(props, " props");
    console.log(location, " useLocation Hook");
    const companyName = location.state?.data;
    const companyAccount = location.state?.data;
    console.log(companyName, companyAccount, "this is companyName ");

    let currentOrderStateText = "";
    const [statusListState, setStatusListState] = useState(null);
    const { id } = useParams();
    const [apiResultArrayState, setApiResultArrayState] = useState(null);
    const [loadingScreenState, setLoadingScreenState] = useState(false);
    const [messageToUser, setMessageToUser] = useState("");

    const [messageToUserAPI, setMessageToUserAPI] = useState("Checking for data");

    const getPreviousOrderSingleDetail = () => {

        axios.get(`${process.env.REACT_APP_BASE_URL}/Sales_Order/salesall/details/${id}`).then((res) => {

            console.log("res", res);
            setApiResultArrayState(res.data);

            if (res.data == null) {
                setMessageToUserAPI("No Data found");
                if (res.data.length == 0) {
                    setMessageToUserAPI("No Data found");
                }
            }

        }).catch((err) => {

            setMessageToUser("something went wrong, please try again later");

            setTimeout(() => {
                setMessageToUser("");
            }, 3000);
            console.log("error is ", err)
        });
    }

    const [currentSelectedStatusArrayIndex, setCurrentSelectedStatusArrayIndex] = useState(0);
    const [showHideStatusListState, setShowHideStatusListState] = useState(false);
    const [showStatusChangePopup, setShowStatusChangePopup] = useState(false);

    const changeStatusOfOrder = () => {

        setLoadingScreenState(true);

        if (statusListState != null) {
            currentOrderStateText = statusListState[currentSelectedStatusArrayIndex].Order_Status
        } else {

        }

        const arrayToSend = [{
            So_no: id,
            changeuser: localStorage.getItem("cubix_order_taking_sales_man"),
            statusto: currentOrderStateText
        }]

        console.log("arrayToSend", arrayToSend);
        axios.post(`${process.env.REACT_APP_BASE_URL}/OrderStatusChange`, arrayToSend).then((res) => {

            setShowStatusChangePopup(false);
            setLoadingScreenState(false);
            console.log("res", res);

        }).catch((err) => {
            setLoadingScreenState(false);
            console.log("error is ", err)
        });

    }

    const changeCurrentSelectedStatus = (selectedIndex) => {
        setCurrentSelectedStatusArrayIndex(selectedIndex);
        setShowHideStatusListState(prev => !prev);
    }

    const getAllStatuses = () => {

        setLoadingScreenState(true);

        axios.get(`${process.env.REACT_APP_BASE_URL}/OrderStatusChange/order`).then((res) => {
            console.log("res is ", res);
            setLoadingScreenState(false);

            if (res.data != null) {
                setStatusListState(res.data)
            }
        }).catch(err => {
            setLoadingScreenState(false);
            console.log("error is ", err)
        });
    }

    useEffect(() => {

        getPreviousOrderSingleDetail();

    }, [])

    const callStatusListAPI = () => {
        getAllStatuses();
    }


    return (
        <div className="PreviousOrderDetailPage-root-container">

            <div className="PreviousOrderDetailPage-layer-1">
                <img src={ic_blue_cube} />
            </div>

            <div className="PreviousOrderDetailPage-layer-2 pb-4">
                <Header />
                <h4>Order Details</h4>



                <div className="PreviousOrderDetailPage-layer-2-underline"></div>

                {
                    apiResultArrayState != null ?

                        apiResultArrayState.length > 0 ?

                            <div className="card PreviousOrderDetailPage-full-details mt-4">

                                <div className="PreviousOrderDetailPage-chnage-status-and-view-pdf">
                                    <span>
                                        <button className="PreviousOrderDetailPage-change-status-button" onClick={() => { callStatusListAPI(); setShowStatusChangePopup(prev => !prev) }}>Change status of Order</button>
                                    </span>

                                    <div className="View-pdf-link-container">
                                        <Link className="View-pdf-link" to={`/view-pdf`} state={{ data: { data_set_from_parent: apiResultArrayState, custName: companyName.company_name_from_parent, invoiceFromParent: id, customerCode: companyName.company_account_from_parent } }}>View PDF</Link>
                                    </div>
                                </div>

                                <div className="customer-code-and-order-id-panel">
                                    <div>
                                        <div className="mt-4 small-label"><small>Customer code</small></div>
                                        <div>
                                            <label className="font-weight-600">{companyName.company_account_from_parent}</label>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="mt-4 small-label"><small>Order Number</small></div>
                                        <div>
                                            <label className="font-weight-600">{id}</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-4 small-label"><small>Customer</small></div>
                                <div>
                                    <label className="font-weight-600">{companyName.company_name_from_parent}</label>
                                </div>
                                <div>
                                    <label className="font-weight-600">{apiResultArrayState[0].address1},{apiResultArrayState[0].address2},{apiResultArrayState[0].address3}</label>
                                </div>
                                {/* <div>
                            <label className="font-weight-600">{salesOrderObjectToSend.company_phone}</label>
                        </div> */}

                                <small className="mt-2">Order Remark</small>

                                <div>
                                    <label className="font-weight-600">{apiResultArrayState[0].OrderRemark}</label>
                                </div>

                                <small className="mt-4 small-label">Item List</small>

                                <div className="ConfirmSalesOrderPopup-list-container">

                                    {
                                        apiResultArrayState != null ?
                                            apiResultArrayState.map((item, index) => {
                                                return (
                                                    <div className="ConfirmSalesOrderPopup-sales-order-list-item" key={index}>
                                                        <div className="ConfirmSalesOrderPopup-sales-order-list-item-first-panel">

                                                            {/* left portion */}
                                                            <div className="left-child pe-3">

                                                                <div className="ConfirmSalesOrderPopup-item-name-qty-container child-2">
                                                                    <label className="ConfirmSalesOrderPopup-itemcode-chip">{item.so_icode}</label>
                                                                    <label className="mt-2">{item.idesc}</label>
                                                                    <div>
                                                                        <small>Quantity : </small>
                                                                        <label>{item.tr_qty2}</label>
                                                                    </div>
                                                                    <div>
                                                                        <small>Unit Price : </small>
                                                                        <label>{item.so_cost}</label>
                                                                    </div>
                                                                    <div>
                                                                        <small>Item Remark : </small>
                                                                        <label>{item.ItemWiseRemark}</label>
                                                                    </div>
                                                                    <div>
                                                                        <small>Item Barcode : </small>
                                                                        <label>{item.BarcodeRemark != null ? item.BarcodeRemark : item.batch}</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* right portion */}
                                                            <div className="right-child child-3">
                                                                <label>{parseFloat((item.line_total).toFixed(2))}</label>
                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :

                                            <p className="PreviousOrderPage-empty-state">No Data to show</p>
                                    }

                                </div>
                                {/* list container ends */}

                                <div>
                                    {/* <div className="ConfirmSalesOrderPopup-subotal-container"><label>Subtotal</label><label>{parseFloat((apiResultArrayState[0].so_amount).toFixed(2))}</label></div> */}

                                    <div className="ConfirmSalesOrderPopup-subotal-container"><label>Subtotal</label><label>{apiResultArrayState != null ? apiResultArrayState.reduce((acc, curr) => {

                                        return acc = acc + Math.round((curr.tr_qty2 * curr.so_cost) * 100) / 100

                                    }, 0) : null}</label></div>

                                </div>

                                <div className="ConfirmSalesOrderPopup-tax-total-container">
                                    <div><label>VAT : </label><label>5%</label></div>
                                    <div><label>VAT : </label><label>

                                        {apiResultArrayState != null ?

                                            ((apiResultArrayState.reduce((acc, curr) => {

                                                return acc = acc + Math.round((curr.tr_qty2 * curr.so_cost) * 100) / 100

                                            }, 0) * 5) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 })

                                            :
                                            null
                                        }
                                    </label></div>

                                    <div><label>Amount Incl.VAT</label>{parseFloat((apiResultArrayState[0].so_amount).toFixed(2))}</div>
                                </div>

                            </div>
                            :

                            <p className="PreviousOrderPage-empty-state-detail-page">{messageToUserAPI}</p>
                        :

                        <p className="PreviousOrderPage-empty-state-detail-page">{messageToUserAPI}</p>

                }

            </div>

            {
                showStatusChangePopup &&

                <div className="PreviousOrderDetailPage-change-status-outer">
                    <div className="PreviousOrderDetailPage-change-status-wrapper mt-2">

                        <span className="PreviousOrderDetailPage-change-status-popup-heading">Change status</span>

                        <div className="PreviousOrderDetailPage-status-current-text-container">

                            <div className="PreviousOrderDetailPage-current-status-and-dropdown-container" onClick={() => setShowHideStatusListState(prev => !prev)}>
                                <span>
                                    {statusListState != null ? statusListState[currentSelectedStatusArrayIndex].Order_Status : null}
                                </span>
                                <img src={ic_dropdown_status} className="ms-2" />
                            </div>

                            {showHideStatusListState &&
                                <div className="PreviousOrderDetailPage-status-text-list-container">
                                    {
                                        statusListState.map((item, index) => {
                                            return (
                                                <div className="PreviousOrderDetailPage-status-text-list-item" onClick={() => changeCurrentSelectedStatus(index)}>
                                                    {item.Order_Status}
                                                </div>
                                            )

                                        })
                                    }
                                </div>
                            }
                        </div>

                        <div className="PreviousOrderDetailPage-popup-cta-container">
                            <button className="PreviousOrderDetailPage-popup-cancel-button" onClick={() => setShowStatusChangePopup(prev => !prev)}>Cancel</button>
                            <button className="PreviousOrderDetailPage-popup-save-button ms-4" onClick={changeStatusOfOrder}>Save</button>
                        </div>

                        <div>
                            {messageToUser}
                        </div>
                    </div>

                    {loadingScreenState &&
                        <div className="LoginPage-Loading-Layout">
                            <div className="LoginPage-Loading-Layout-child card">
                                <LoadingUI />
                            </div>
                        </div>
                    }
                </div>
            }

        </div>
    )
}

export default PreviousOrderDetailPage;